import * as React from "react";
import Modal from "./Modal";
import ModalHeader from "./ModalHeader";
import ModalBody from "./ModalBody";
import ModalFooter from "./ModalFooter";
import Button from "./Button";
import FormGroup from "./FormGroup";
import FieldError from "./FieldError";
import isEmailAddressValid from "../helpers/isEmailAddressValid";
import { useState } from "react";
import useConfig from "../hooks/useConfig";

interface Props {
  onSubmit: (emailAddress: string) => void;
  onCancel: () => void;
}

export default function EmailModal(props: Props) {
  const [emailAddress, setEmailAddress] = useState("");
  const [invalidEmailAddress, setInvalidEmailAddress] = useState(false);
  const config = useConfig();

  function onChangeEmailAddress(e: React.FormEvent<HTMLInputElement>) {
    setEmailAddress(e.currentTarget.value);
  }

  function onSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();

    if (!isEmailAddressValid(emailAddress)) {
      setInvalidEmailAddress(true);
      return;
    }

    props.onSubmit(emailAddress);
  }

  return (
    <Modal>
      <ModalHeader>{config.EmailModalTitleText}</ModalHeader>
      <form onSubmit={onSubmit}>
        <ModalBody>
          <FormGroup>
            <label>{config.EmailModalInputLabelText}</label>
            <input
              type="text"
              value={emailAddress}
              onChange={onChangeEmailAddress}
              autoFocus
            />
            {invalidEmailAddress && (
              <FieldError>{config.EmailModalValidationText}</FieldError>
            )}
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button variant="secondary" onClick={props.onCancel}>
            {config.EmailModalCancelButtonText}
          </Button>
          <Button variant="primary" type="submit">
            {config.EmailModalSubmitButtonText}
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  );
}
